<template>
  <div class="AssetReg">    
    <div class="page-title">{{title}}</div>
    <div>
      <div class="inline">
        <ADatePicker
          v-model="searchDate"
          placeholder="날짜 선택"
          :clearable="false"
          @change="handleChangeDate"
        />
      </div>
    </div>
    <div class="row-splitter">
      <el-tabs ref="tabs" v-model="activeTab" type="card" @tab-click="handleTabClicked()">
        <el-tab-pane label="일계표" name="1">
          <AssetDayView                  
            :items="items"
            :loading="loading"
          />
        </el-tab-pane>
        <el-tab-pane label="출납장" name="2">
          <AssetForm   
            ref="form"
            v-if="activeTab === '2'"
            :date="searchDate"   
            :items="items"
            :loading="loading"
            :has_grant_write="has_grant_write"
            @completed="handelFormCompleted"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { authority_level } from "@/common/mixins/authority_level";
import AssetDayView from "./AssetDayView"
import AssetForm from "./AssetForm"

export default {
  name: "AssetReg",
  mixins: [authority_level],
  components: {AssetDayView, AssetForm},
  data() {
    return {
      title: this.$t("title.asset_reg"),
      searchDate: this.util.getDate(),
      activeTab: '1',
      items: [],
      loading: false,
      add_new_row: false,
    }
  },
  computed: {
    ...mapGetters(['table_customer']),
    has_grant_write() {
      return this.isWriteLevel('asset_reg');
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.items = [];
      let period = {
        startDate: this.searchDate,
        endDate: this.searchDate,
      }
      this.api.listAsset(period).then(res => {
        let items = res.data;
        this.organizeData(items);
        this.items = items;
        this.loading = false;
        if (!this.add_new_row) { return; }
        this.$nextTick(() => {
          this.$refs.form.handleClickedCreate();
          this.add_new_row = false;
        });
      });
    },
    organizeData(items) {
      items.forEach(item => {
        if (item.customer_id) {
          let customer = this.table_customer.find(c => c.id === item.customer_id);
          if (customer) {
            item.customer_name = customer.name;
          }
        }
      })
    },
    handleChangeDate() {
      this.loadData();
    },
    handelFormCompleted(add_new_row) {
      this.add_new_row = add_new_row; 
      this.loadData();
    },
    handleTabClicked() {
      this.loadData();
    },
  },
}
</script>
